import React from 'react';
import { Grid, withStyles } from '@material-ui/core';
import { LabeledCheckbox } from '../../../../../common/MUI';
import { PHYSICAL_DR_CONTENT } from '../../PrintPhysicalDr/content';
import StyledToolTip from '../../../../../common/StyledToolTip';

import {
  TrailerDetail,
  hasAnyPhysicalDrNeed,
  isTrailerSelected as isTrailerSelectedUtil,
  getCheckboxState
} from '../../PrintPhysicalDr/utils/dispatchPanelUtils';

const styles = (theme: any) => ({
  sectionHeader: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.dispatchPanelHeaderColor,
    lineHeight: '16px',
    fontWeight: 500,
    paddingTop: 8,
    paddingBottom: 8,
    letterSpacing: '1.5px',
    textTransform: 'uppercase' as const,
    paddingLeft: 20
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 16
  }
});

interface PaperDeliveryReceiptSectionProps {
  classes: Record<string, string>;
  trailerDetails: TrailerDetail[];
  isPrintPhysicalDrChecked: boolean;
  onPrintCheckboxChange: (checked: boolean) => void;
}

const PaperDeliveryReceiptSection: React.FC<PaperDeliveryReceiptSectionProps> = ({
  classes,
  trailerDetails,
  isPrintPhysicalDrChecked,
  onPrintCheckboxChange
}) => {
  const isTrailerSelected = isTrailerSelectedUtil(trailerDetails);
  const isPhysicalDrNeed = hasAnyPhysicalDrNeed(trailerDetails);

  const { isDisabled, tooltipText } = getCheckboxState({
    isTrailerSelected,
    isPhysicalDrNeed
  });
  const checked = isDisabled ? false : isPrintPhysicalDrChecked;

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isDisabled) {
      return;
    }
    onPrintCheckboxChange(event.target.checked);
  };

  const checkbox = (
    <LabeledCheckbox
      disabled={isDisabled}
      checked={checked}
      onChange={handleCheckboxChange}
      label={PHYSICAL_DR_CONTENT.dispatchPanel.checkboxLabel}
    />
  );

  return (
    <>
      <Grid item xs={12} className={classes.sectionHeader}>
        {PHYSICAL_DR_CONTENT.dispatchPanel.sectionHeader}
      </Grid>
      <div className={classes.container}>
        {isDisabled ? (
          <StyledToolTip title={tooltipText}>
            <span>{checkbox}</span>
          </StyledToolTip>
        ) : (
          checkbox
        )}
      </div>
    </>
  );
};

export default withStyles(styles)(PaperDeliveryReceiptSection);
